import { render, staticRenderFns } from "./TaxViewLogs.vue?vue&type=template&id=5a51698c&"
import script from "./TaxViewLogs.vue?vue&type=script&lang=js&"
export * from "./TaxViewLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports